<script lang="ts">
    import { VpEmotionSadIcon } from '@decathlon-experience/icons/svelte';
</script>

<div class="flex flex-col items-center justify-center p-xl">
    <VpEmotionSadIcon class="size-xl text-content-brand" />
    <span>Aucun résultat trouvé</span>
    <span class="text-xs">Réessayez ou laissez-vous inspirer !</span>
</div>
